import { KText } from '@/ui-library/components';
import {
  AssociatedJobCell,
  CandidateNameCell,
  CloseReasonCell,
  CreatedByCell,
  RequisitionIdCell,
  RequisitionStatusCell,
  RequisitionTypeCell,
  RoleNameCell,
  TimeToFillCell,
} from '../cells/RequisitionsDrilldownCells';

const renderDrilldownHeader = (title: string) => () => (
  <KText size="sm-medium" color="secondary-900" textTransform="none">
    {title}
  </KText>
);

export const useRequisitionsDrilldownConfig = ({
  drilldownHeading = 'Requisitions',
  onSort: _onSort = () => {},
  currentSort: _currentSort = {},
}) => {
  const getColumnConfig = () => {
    const columnsMap = {
      requisitionId: {
        title: 'Requisition ID',
        columnConfig: false,
        Header: renderDrilldownHeader('Requisition ID'),
        width: 250,
        accessor: 'requisition_code',
        sort: true,
        filterable: true,
        Cell: ({ row }) => RequisitionIdCell(row),
      },
      roleName: {
        title: 'Role name',
        Header: renderDrilldownHeader('Role name'),
        width: 200,
        accessor: 'role_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => RoleNameCell(row),
      },
      requisitionStatus: {
        title: 'Requisition status',
        Header: renderDrilldownHeader('Requisition status'),
        width: 200,
        accessor: 'requisition_status',
        sort: true,
        filterable: true,
        Cell: ({ row }) => RequisitionStatusCell(row),
      },
      associatedJob: {
        title: 'Associated job',
        Header: renderDrilldownHeader('Associated job'),
        width: 220,
        accessor: 'associated_job_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => AssociatedJobCell(row),
      },
      requisitionType: {
        title: 'Requisition type',
        Header: renderDrilldownHeader('Requisition type'),
        width: 180,
        accessor: 'requisition_type',
        sort: true,
        filterable: true,
        Cell: ({ row }) => RequisitionTypeCell(row),
      },
      createdBy: {
        title: 'Created by',
        Header: renderDrilldownHeader('Created by'),
        width: 220,
        accessor: 'requester',
        sort: true,
        filterable: true,
        Cell: ({ row }) => CreatedByCell(row),
      },
      candidateName: {
        title: 'Candidate name',
        Header: renderDrilldownHeader('Candidate name'),
        width: 200,
        accessor: 'filled_candidate_name',
        sort: true,
        filterable: true,
        Cell: ({ row }) => CandidateNameCell(row),
      },
      closeReason: {
        title: 'Close reason',
        Header: renderDrilldownHeader('Close reason'),
        width: 200,
        accessor: 'rejection_reason',
        sort: true,
        filterable: true,
        Cell: ({ row }) => CloseReasonCell(row),
      },
      timeToFill: {
        title: 'Time to fill',
        Header: renderDrilldownHeader('Time to fill'),
        width: 200,
        accessor: 'time_to_fill',
        sort: true,
        filterable: true,
        Cell: ({ row }) => TimeToFillCell(row),
      },
    };

    switch (drilldownHeading) {
      case 'Requisitions opened':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.requisitionStatus,
          columnsMap.associatedJob,
          columnsMap.requisitionType,
          columnsMap.createdBy,
        ];
      case 'Requisitions filled':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.candidateName,
          columnsMap.associatedJob,
          columnsMap.requisitionType,
          columnsMap.createdBy,
        ];
      case 'Requisitions closed':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.closeReason,
          columnsMap.requisitionType,
          columnsMap.createdBy,
        ];
      case 'Avg. time to fill':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.timeToFill,
          columnsMap.candidateName,
          columnsMap.associatedJob,
          columnsMap.requisitionType,
          columnsMap.createdBy,
        ];

      case 'Requisitions by requisition type':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.requisitionStatus,
          columnsMap.associatedJob,
          columnsMap.createdBy,
        ];

      case 'Percentage of requisitions filled by department':
        return [
          columnsMap.requisitionId,
          columnsMap.roleName,
          columnsMap.candidateName,
          columnsMap.associatedJob,
          columnsMap.requisitionType,
          columnsMap.createdBy,
        ];
    }
    return [
      columnsMap.requisitionId,
      columnsMap.roleName,
      columnsMap.requisitionStatus,
      columnsMap.associatedJob,
      columnsMap.requisitionType,
      columnsMap.createdBy,
    ];
  };

  return { columnConfig: getColumnConfig() };
};
